import { useEffect, useState } from 'react';
import {
  DEFAULT_PAYMENT_LAG_SETTINGS,
  type PaymentLagSettings,
} from '../utils/paymentDueFlags';
import { subscribePaymentLagSettings } from '../utils/paymentTermsSettings';

/** Live `financeSettings/paymentTerms` lag settings; defaults until loaded. */
export function usePaymentLagSettings(): {
  lagSettings: PaymentLagSettings;
  loading: boolean;
} {
  const [lagSettings, setLagSettings] = useState<PaymentLagSettings>({
    ...DEFAULT_PAYMENT_LAG_SETTINGS,
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    return subscribePaymentLagSettings(settings => {
      setLagSettings(settings);
      setLoading(false);
    });
  }, []);

  return { lagSettings, loading };
}
